import * as authDashboard from 'api/dashboard'
import * as action from 'actions'
import {call, put, takeLatest, takeEvery, cancel} from 'redux-saga/effects'
import {change, initialize} from 'redux-form'
import {getFilteredDateAsMoment} from 'sagas/api/get-filtered-date'
import moment from 'moment'
import {setDashboard, setOutlets, setFlagAsyncDashboard, setFilterDataAsyncDashboard, setFlagErrorPusherAsyncDashboard} from 'actions/dashboard'
import * as actActionBar from 'actions/actionBar'
import {getProfile} from 'sagas/api/profile'
import {loginOutlet} from 'sagas/api/login'
import * as apiOutlet from 'api/outlets'
import {
  ASYNC_RESPONSE_CODE
} from 'sagas/constants'
import {
  GET_DASHBOARD_REQUEST,
  DASHBOARD_CHANGE_OUTLET,
  DASHBOARD_PAGE_REQUEST,
  DASHBOARD_CHANGE_DATE,
  DASHBOARD_GET_DATA_URL_ASYNC
} from 'actions/dashboard/constants'
import {
  LOGOUT
} from 'actions/constants'
import * as actNotification from 'actions/notifications'
import * as apiProfile from 'api/profile'
import {showPageLoadingSpinner} from 'actions/loadingSpinner'
import * as mpDashboard from 'mixpanel/dashboard'

export function * pageRequest (request) {
  let {payload} = request
  let {flagAsync, outletsAsync, startDateAsync, endDateAsync, currentDashboardData} = payload
  let selectedOutletAsync
  let selectedStartDateAsync
  let selectedEndDateAsync
  let isSameDate
  yield put(setDashboard({
    gross_sales: 0,
    net_sales: 0,
    total_transactions: 0,
    top_items: [],
    transactions: [],
    dailyGrossSales: [],
    weeklyGrossSales: [],
    hourlyGrossSales: [],
    categorySalesAmountByRevenue: {},
    categorySalesAmountByVolume: {},
    topItemsByCategory: {},
    tableManagementReport: {}
  }))
  try {
    yield put(action.showProgressBar())
    yield put(showPageLoadingSpinner(true))
    const data = yield call(getFilteredDateAsMoment)
    const {startDate, endDate} = data

    const resOutlet = yield call(apiOutlet.outlets)
    yield put(setOutlets(resOutlet.data))
    yield put(actActionBar.setOutlets(resOutlet.data))

    const resProfile = yield call(apiProfile.getProfile)
    yield put(actActionBar.setSelectedOutletIds(resProfile.data.outlet_id))

    // set outlet id jika proses async terjadi
    outletsAsync.length > 0 ? selectedOutletAsync = outletsAsync : selectedOutletAsync = resProfile.data.outlet_id

    // set date jika proses async terjadi
    if (startDateAsync !== null && endDateAsync !== null) {
      selectedStartDateAsync = startDateAsync
      selectedEndDateAsync = endDateAsync
    } else {
      selectedStartDateAsync = startDate
      selectedEndDateAsync = endDate
    }

    // init form value
    yield put(initialize('search', {
      'date': {startDate: selectedStartDateAsync, endDate: selectedEndDateAsync},
      'outlet': selectedOutletAsync
    }))

    // cek antara outlet id async dengan outlet id current selected jika proses async selesai
    let isSameOutlet
    if (selectedOutletAsync.length === outletsAsync.length) {
      if (selectedOutletAsync.length > 1 && outletsAsync.length > 1) {
        isSameOutlet = true
      } else if (selectedOutletAsync.length === 1 && outletsAsync.length === 1) {
        selectedOutletAsync[0] === outletsAsync[0] ? isSameOutlet = true : isSameOutlet = false
      }
    } else {
      isSameOutlet = false
    }
    // cek antara date async dengan date  current selected jika proses async selesai
    if (startDateAsync !== null && endDateAsync !== null) {
      isSameDate = selectedStartDateAsync.format('YYYY-MM-DD') === startDateAsync.format('YYYY-MM-DD') && selectedEndDateAsync.format('YYYY-MM-DD') === endDateAsync.format('YYYY-MM-DD')
    } else {
      isSameDate = false
    }

    // call dashboard api
    const query = {
      startDate: selectedStartDateAsync.format('YYYY-MM-DD 00:00:00'),
      endDate: selectedEndDateAsync.format('YYYY-MM-DD 23:59:59'),
      outletIds: selectedOutletAsync
    }
    if (!flagAsync && !isSameOutlet && !isSameDate) {
      let tableManagementReport = {}
      try {
        tableManagementReport = yield call(authDashboard.getTableDashboard, { startDate: query.startDate, endDate: query.endDate, outletIds: query.outletIds.join() })
      } catch (error) {
        yield put(actNotification.error('Failed to load data'))
      } finally {
      }
      try {
        const dashboardData = yield call(authDashboard.dashboardPost, query)
        if (dashboardData.status === ASYNC_RESPONSE_CODE) {
          yield put(setFlagAsyncDashboard(true))
          yield put(setFilterDataAsyncDashboard(selectedOutletAsync, selectedStartDateAsync, selectedEndDateAsync))
        } else {
          let objdashboardData
          if (dashboardData.data.top_items) {
            objdashboardData = {
              categorySalesAmountByRevenue: dashboardData.data.categorySalesAmountByRevenue,
              categorySalesAmountByVolume: dashboardData.data.categorySalesAmountByVolume,
              top_items: dashboardData.data.top_items,
              topItemsByCategory: dashboardData.data.topItemsByCategory
            }
          } else {
            objdashboardData = {
              categorySalesAmountByRevenue: {},
              categorySalesAmountByVolume: {},
              top_items: [],
              topItemsByCategory: {}
            }
          }
          yield put(setFlagAsyncDashboard(false))
          yield put(setDashboard(objdashboardData))
          const dashboardDataSummary = yield call(authDashboard.dashboardSummaryPost, query)
          yield put(setDashboard({...dashboardDataSummary.data, tableManagementReport: tableManagementReport.data}))
          yield put(showPageLoadingSpinner(false))
        }
        yield put(setFlagErrorPusherAsyncDashboard(false))
      } catch (error) {
        yield put(setFlagErrorPusherAsyncDashboard(true))
        yield put(setFilterDataAsyncDashboard([], null, null))
        yield put(setFlagAsyncDashboard(false))
        yield put(showPageLoadingSpinner(false))
        yield put(actNotification.error('Failed to load data'))
      } finally {
        // yield put(showPageLoadingSpinner(false))
        yield put(action.hideProgressBar())
      }
    } else {
      yield put(setDashboard(currentDashboardData))
      yield put(setFlagAsyncDashboard(false))
      yield put(showPageLoadingSpinner(false))
    }
    mpDashboard.dashboardStart({
      outletIds: resProfile.data.outlet_id,
      startDate,
      endDate
    })
  } catch (error) {
    yield put(actNotification.error(error.message))
  } finally {
    yield put(action.hideProgressBar())
  }
}

export function * getDashboardRequestFlow (request) {
  yield put(showPageLoadingSpinner(true))
  let {payload} = request
  let {query} = payload
  if (!query) {
    // kalo gak ada startdate sama enddate, panggil api calendar untuk mengetahui current date
    let data = yield call(getFilteredDateAsMoment)
    let {startDate, endDate} = data
    yield put(change('search', 'date', {startDate, endDate}))
    query = {
      start_date: startDate.format('D/M/YYYY'),
      end_date: endDate.format('D/M/YYYY')
    }
  }

  yield put(action.sendingRequest(true))
  yield put(action.showProgressBar())
  const resOutlet = yield call(apiOutlet.outlets)
  yield put(setOutlets(resOutlet.data))
  try {
    const profileData = yield call(getProfile)
    yield put(change('search', 'outlet', profileData.outlet_id))
    // yield put(actOutlet.setCurrentOutlet(profileData))

    const dashboardData = yield call(authDashboard.dashboard, query)
    yield put(setDashboard(dashboardData.data))
  } catch (error) {
    yield put(actNotification.error(error.message))
  } finally {
    yield put(action.sendingRequest(false))
    yield put(action.hideProgressBar())
    yield put(showPageLoadingSpinner(false))
  }
}

export function * changeOutletFlow (request) {
  yield put(setDashboard({
    gross_sales: 0,
    net_sales: 0,
    total_transactions: 0,
    top_items: [],
    transactions: [],
    dailyGrossSales: [],
    weeklyGrossSales: [],
    hourlyGrossSales: [],
    categorySalesAmountByRevenue: {},
    categorySalesAmountByVolume: {},
    topItemsByCategory: {},
    tableManagementReport: {}
  }))
  // yield put(showPageLoadingSpinner(true))
  let {payload} = request
  let {outletIds, startDate, endDate} = payload
  yield put(showPageLoadingSpinner(true))
  yield call(loginOutlet, {id: outletIds})
  yield put(change('search', 'date', {startDate, endDate}))
  yield put(change('search', 'outlet', outletIds))
  yield put(actActionBar.setSelectedOutletIds(outletIds))
  let tableManagementReport = { }
  try {
    tableManagementReport = yield call(authDashboard.getTableDashboard, {startDate: startDate.format('YYYY-MM-DD 00:00:00'), endDate: endDate.format('YYYY-MM-DD 23:59:59'), outletIds: outletIds.join()})
    yield put(setFlagErrorPusherAsyncDashboard(false))
  } catch (error) {
    yield put(actNotification.error('Failed to load data'))
  } finally {
  }

  try {
    const queryParams = {startDate: startDate.format('YYYY-MM-DD 00:00:00'), endDate: endDate.format('YYYY-MM-DD 23:59:59'), outletIds: outletIds}
    const dashboardData = yield call(authDashboard.dashboardPost, queryParams)
    if (dashboardData.status === ASYNC_RESPONSE_CODE) {
      yield put(setFlagAsyncDashboard(true))
      yield put(setFilterDataAsyncDashboard(outletIds, startDate, endDate))
    } else {
      let objdashboardData
      if (dashboardData.data.top_items) {
        objdashboardData = {
          categorySalesAmountByRevenue: dashboardData.data.categorySalesAmountByRevenue,
          categorySalesAmountByVolume: dashboardData.data.categorySalesAmountByVolume,
          top_items: dashboardData.data.top_items,
          topItemsByCategory: dashboardData.data.topItemsByCategory
        }
      } else {
        objdashboardData = {
          categorySalesAmountByRevenue: {},
          categorySalesAmountByVolume: {},
          top_items: [],
          topItemsByCategory: {}
        }
      }
      yield put(setFilterDataAsyncDashboard([], null, null))
      yield put(setFlagAsyncDashboard(false))
      yield put(setDashboard(objdashboardData))
      const dashboardDataSummary = yield call(authDashboard.dashboardSummaryPost, queryParams)
      yield put(setDashboard({...dashboardDataSummary.data, tableManagementReport: tableManagementReport.data}))
      yield put(showPageLoadingSpinner(false))
    }
    yield put(setFlagErrorPusherAsyncDashboard(false))
  } catch (error) {
    yield put(setFlagErrorPusherAsyncDashboard(true))
    yield put(setFilterDataAsyncDashboard([], null, null))
    yield put(setFlagAsyncDashboard(false))
    yield put(showPageLoadingSpinner(false))
    yield put(actNotification.error('Failed to load data'))
  } finally {
    yield put(action.hideProgressBar())
    // yield put(showPageLoadingSpinner(false))
  }
}

export function * changeDateFlow (request) {
  yield put(setDashboard({
    gross_sales: 0,
    net_sales: 0,
    total_transactions: 0,
    top_items: [],
    transactions: [],
    dailyGrossSales: [],
    weeklyGrossSales: [],
    hourlyGrossSales: [],
    categorySalesAmountByRevenue: {},
    categorySalesAmountByVolume: {},
    topItemsByCategory: {},
    tableManagementReport: {}
  }))
  let tableManagementReport = {}
  try {
    const {payload: {startDate, endDate, outlet}} = request
    const queryParams = {startDate: moment(startDate).format('YYYY-MM-DD 00:00:00'), endDate: moment(endDate).format('YYYY-MM-DD 23:59:59'), outletIds: outlet.join()}
    tableManagementReport = yield call(authDashboard.getTableDashboard, queryParams)
  } catch (error) {
    yield put(actNotification.error('Failed to load data'))
  } finally {
  }

  try {
    yield put(showPageLoadingSpinner(true))
    const {payload: {startDate, endDate, outlet}} = request
    const queryParams = {startDate: moment(startDate).format('YYYY-MM-DD 00:00:00'), endDate: moment(endDate).format('YYYY-MM-DD 23:59:59'), outletIds: outlet}
    const dashboardData = yield call(authDashboard.dashboardPost, queryParams)
    if (dashboardData.status === ASYNC_RESPONSE_CODE) {
      yield put(setFlagAsyncDashboard(true))
      yield put(setFilterDataAsyncDashboard(outlet, startDate, endDate))
    } else {
      let objdashboardData
      if (dashboardData.data.top_items) {
        objdashboardData = {
          categorySalesAmountByRevenue: dashboardData.data.categorySalesAmountByRevenue,
          categorySalesAmountByVolume: dashboardData.data.categorySalesAmountByVolume,
          top_items: dashboardData.data.top_items,
          topItemsByCategory: dashboardData.data.topItemsByCategory
        }
      } else {
        objdashboardData = {
          categorySalesAmountByRevenue: {},
          categorySalesAmountByVolume: {},
          top_items: [],
          topItemsByCategory: {}
        }
      }
      yield put(setFilterDataAsyncDashboard([], null, null))
      yield put(setFlagAsyncDashboard(false))
      yield put(setDashboard(objdashboardData))
      const dashboardDataSummary = yield call(authDashboard.dashboardSummaryPost, queryParams)
      yield put(setDashboard({...dashboardDataSummary.data, tableManagementReport: tableManagementReport.data}))
      yield put(showPageLoadingSpinner(false))
    }
    yield put(setFlagErrorPusherAsyncDashboard(false))
  } catch (error) {
    yield put(setFlagErrorPusherAsyncDashboard(true))
    yield put(setFilterDataAsyncDashboard([], null, null))
    yield put(setFlagAsyncDashboard(false))
    yield put(showPageLoadingSpinner(false))
    yield put(actNotification.error('Failed to load data'))
  } finally {
    yield put(action.hideProgressBar())
   // yield put(showPageLoadingSpinner(false))
  }
}

export function * getDataAsyncDashboardFlow (request) {
  const {payload: {results, filterHeader}} = request
  const {startDate, endDate} = filterHeader.date
  let outletIds = filterHeader.outlet
  let isSameOutlet
  if (outletIds.length === results.outletIds.length) {
    if (outletIds.length > 1 && results.outletIds.length > 1) {
      isSameOutlet = true
    } else if (outletIds.length === 1 && results.outletIds.length === 1) {
      outletIds[0] === results.outletIds[0] ? isSameOutlet = true : isSameOutlet = false
    }
  } else {
    isSameOutlet = false
  }
  let isSameDate = startDate.format('YYYY-MM-DD') === results.startDate.split(' ')[0] && endDate.format('YYYY-MM-DD') === results.endDate.split(' ')[0]
  if (isSameOutlet && isSameDate) {
    const dashboardData = yield call(authDashboard.getDataAsync, results.url)
    if (!dashboardData.data.gross_sales) {
      yield put(setFlagErrorPusherAsyncDashboard(true))
      yield put(setFilterDataAsyncDashboard([], null, null))
      yield put(setFlagAsyncDashboard(false))
      yield put(showPageLoadingSpinner(false))
    } else {
      yield put(setDashboard(dashboardData.data))
      yield put(showPageLoadingSpinner(false))
    }
  }
}

export function * cancelAction (args) {
  yield cancel(...args)
}

export default function * dashboardSaga () {
  const pageReqTask = yield takeLatest(DASHBOARD_PAGE_REQUEST, pageRequest)
  const task = yield takeLatest(GET_DASHBOARD_REQUEST, getDashboardRequestFlow)
  const task2 = yield takeLatest(DASHBOARD_CHANGE_OUTLET, changeOutletFlow)
  const changeDateTask = yield takeLatest(DASHBOARD_CHANGE_DATE, changeDateFlow)
  const getDataAsyncDashboard = yield takeLatest(DASHBOARD_GET_DATA_URL_ASYNC, getDataAsyncDashboardFlow)

  yield takeEvery(LOGOUT, cancelAction, [task, task2, pageReqTask, changeDateTask, getDataAsyncDashboard])
}



// WEBPACK FOOTER //
// ./app/sagas/dashboard/index.js